// @flow

import { Component } from '~/sources/scripts/jsti/core';
import Notifications from '../constants/Notifications';

export default class CurrentVariantSelection extends Component {
  /**
   * Instantiate the component
   */
  bind(el: HTMLElement): void {
    super.bind(el);

    this.addListener(Notifications.CHANGE_PRODUCT, ({ product }: { product: Object }) => {
      this.el.innerHTML = product.name;
    });
  }
}
